import { action, atom } from '@reatom/framework'

import { AsyncStateN, Result } from '@blade/std-lib'
import { currencyRegistry } from '@root/entities/currency/atoms'
import { selectedNetworkAtom } from '@root/entities/network'
import { premiumMetaRegistry } from '@root/entities/premium'
import { type Error } from '@root/shared'

import { checkCurrencyRequestAction } from './check-currency-requests'

import type { CurrencyNotFoundError } from './check-currency-requests'
import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'

export * from './check-currency-requests'
export * from './reatom-currency-check'

export type CurrencySafetyCheck = {
  currency: CurrencyModel
  hasPassedSecurityChecks: boolean
  premiumInfo: PremiumMetaModel | undefined
}

/**
 * @deprecated
 */
export const checkCurrencyReatom = (
  _: undefined,
  { name }: { name?: string },
) => {
  const checkCurrencyStateAtom = atom(
    AsyncStateN.notInitiated<
      Error.UnknownError | CurrencyNotFoundError,
      CurrencySafetyCheck
    >(),
    `${name}.checkCurrencyStateAtom`,
  )

  const resetCheckStateAction = action((ctx) => {
    checkCurrencyStateAtom(ctx, AsyncStateN.notInitiated())
  }, `${name}.resetCheckStateAction`)

  const checkCurrencyAction = action(
    async (ctx, { address }: { address: string }) => {
      const network = ctx.get(selectedNetworkAtom)
      checkCurrencyStateAtom(ctx, AsyncStateN.loading())

      const result = await ctx.schedule(() =>
        checkCurrencyRequestAction(ctx, { address, network }),
      )

      const mappedResult = Result.map(result, (it) => {
        const currency = currencyRegistry.resolveFromTokenMeta(ctx, it.currency)
        return {
          currency: currency,
          hasPassedSecurityChecks: it.hasPassedSecurityChecks,
          premiumInfo: it.premiumInfo
            ? premiumMetaRegistry.resolve(ctx, {
                dto: it.premiumInfo,
                currency,
              })
            : undefined,
        }
      })

      checkCurrencyStateAtom(ctx, AsyncStateN.fromResult(mappedResult))
    },
    `${name}.checkCurrencyAction`,
  )

  return {
    checkCurrencyStateAtom,
    checkCurrencyAction,
    resetCheckStateAction,
  }
}

export type CheckCurrencyReatom = ReturnType<typeof checkCurrencyReatom>
